"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  JobSeachProfile: ['job-seach-profile', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M23.136,23.25l.1-1.122a3,3,0,0,0-2.337-3.2l-3.651-.811V12.375A1.877,1.877,0,0,0,15.3,10.5a1.793,1.793,0,0,0-1.8,1.876v9.2l-1.477-1.108a1.533,1.533,0,0,0-2.146,2.145l.475.633', 'M6.75,19.32H2.25a1.5,1.5,0,0,1-1.5-1.5V2.25A1.5,1.5,0,0,1,2.25.75h13.5a1.5,1.5,0,0,1,1.5,1.5V7.5', 'M6.375 6.375 A2.625 2.625 0 1 0 11.625 6.375 A2.625 2.625 0 1 0 6.375 6.375 Z', 'M11.017,10.218A4.546,4.546,0,0,0,9,9.75a4.485,4.485,0,0,0-4.224,3,4.534,4.534,0,0,0-.264,1.5', 'M4.5 14.25L10.5 14.25']],
  JobSearch: ['job-search', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M.817,8.25A9.071,9.071,0,0,1,13.356,1.5', 'M16.982,15.268A9.063,9.063,0,0,1,3.05,15.92', 'M16.154 16.22L23.183 23.25', 'M5.183,5.25v6a1.5,1.5,0,0,1-1.5,1.5h-1.5', 'M9.683,5.25a1.5,1.5,0,0,0-1.5,1.5v4.5a1.5,1.5,0,0,0,3,0V6.75A1.5,1.5,0,0,0,9.683,5.25Z', 'M14.183 12.75L14.183 5.25', 'M14.183,5.25h1.5a1.5,1.5,0,0,1,1.5,1.5V7.5a1.5,1.5,0,0,1-1.5,1.5h-1.5', 'M14.183,9h1.5a1.5,1.5,0,0,1,1.5,1.5v.75a1.5,1.5,0,0,1-1.5,1.5h-1.5', 'M23.183,5.25h-1.5a1.5,1.5,0,0,0-1.5,1.5c0,2.25,3,2.25,3,4.5a1.5,1.5,0,0,1-1.5,1.5h-1.5']],
  JobSeachMan: ['job-seach-man', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5',
    transform: 'translate(-3.27 4.943) rotate(-23.025)'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M1.500 10.500 A9.000 9.000 0 1 0 19.500 10.500 A9.000 9.000 0 1 0 1.500 10.500 Z', 'M16.863 16.865L22.5 22.5', 'M7.500 7.500 A3.000 3.000 0 1 0 13.500 7.500 A3.000 3.000 0 1 0 7.500 7.500 Z', 'M10.5 12L10.5 16.5', 'M14.724,15a4.474,4.474,0,0,0-8.449,0']],
  JobSeachTeamWoman: ['job-seach-team-woman', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M20.568,15.14a3.375,3.375,0,0,1-5.984-1.2', 'M17.111,23.25h6A5.25,5.25,0,0,0,17.861,18a5.135,5.135,0,0,0-2.12.455', 'M10.375 6.014 A5.250 5.250 0 1 0 20.875 6.014 A5.250 5.250 0 1 0 10.375 6.014 Z', 'M23.125 13.514L19.361 9.75', 'M3.376,10.986v1a5.9,5.9,0,0,1-.859,3.272', 'M11.655,12.69a5.573,5.573,0,0,0,.828,2.564', 'M3.388,11.2A5.483,5.483,0,0,0,7.5,9.305a5.571,5.571,0,0,0,1.984,1.454', 'M11.323,12.427A4.125,4.125,0,1,1,7.5,6.75c.1,0,.194,0,.289.01', 'M14.25,23.25a6.742,6.742,0,0,0-4.243-6.257L7.5,19.5,4.993,16.993A6.742,6.742,0,0,0,.75,23.25']],
  JobChooseCadidate1: ['job-choose-cadidate-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M19.636,23.25l.1-1.122a3,3,0,0,0-2.337-3.2l-3.651-.811V12.375a1.875,1.875,0,0,0-3.75,0v9.2L8.523,20.472a1.533,1.533,0,0,0-2.146,2.145l.475.633', 'M8.875 3.375 A2.625 2.625 0 1 0 14.125 3.375 A2.625 2.625 0 1 0 8.875 3.375 Z', 'M13.787,7.415A4.263,4.263,0,0,0,9.235,7.4', 'M2.125 10.125 A2.625 2.625 0 1 0 7.375 10.125 A2.625 2.625 0 1 0 2.125 10.125 Z', 'M6.651,13.949A4.25,4.25,0,0,0,1,15.75', 'M6.25 4.5L4.75 4.5', 'M6.25 1.5L4.75 0.75', 'M16.75 4.5L18.25 4.5', 'M16.75 1.5L18.25 0.75', 'M16.375 10.125 A2.625 2.625 0 1 0 21.625 10.125 A2.625 2.625 0 1 0 16.375 10.125 Z', 'M17.1,13.949a4.25,4.25,0,0,1,5.651,1.8']],
  JobChooseCandidate: ['job-choose-candidate', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M23.011,23.25l.1-1.122a3,3,0,0,0-2.337-3.2l-3.651-.811V12.375a2.029,2.029,0,0,0-1.949-1.86,1.846,1.846,0,0,0-1.8,1.86v9.2L11.9,20.472a1.533,1.533,0,0,0-2.146,2.145l.475.633', 'M12.250 3.375 A2.625 2.625 0 1 0 17.500 3.375 A2.625 2.625 0 1 0 12.250 3.375 Z', 'M18.625,9a4.25,4.25,0,0,0-7.5,0', 'M1.750 12.375 A2.625 2.625 0 1 0 7.000 12.375 A2.625 2.625 0 1 0 1.750 12.375 Z', 'M8.125,18a4.25,4.25,0,0,0-7.5,0', 'M9.625 4.5L8.125 4.5', 'M9.625 1.5L8.125 0.75', 'M20.125 4.5L21.625 4.5', 'M20.125 1.5L21.625 0.75']],
  JobSeachTeamMan: ['job-seach-team-man', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M.611,23.25a6.75,6.75,0,0,1,13.5,0', 'M3.806,8.781a6.848,6.848,0,0,0,4.93,2.094', 'M10.591,13.44a4.125,4.125,0,1,1-3.23-6.69,4.237,4.237,0,0,1,.6.043', 'M20.568,15.14a3.375,3.375,0,0,1-5.984-1.2', 'M17.111,23.25h6A5.25,5.25,0,0,0,17.861,18a5.135,5.135,0,0,0-2.12.455', 'M10.375 6.014 A5.250 5.250 0 1 0 20.875 6.014 A5.250 5.250 0 1 0 10.375 6.014 Z', 'M23.125 13.514L19.361 9.75', 'M7.361 16.5L7.361 19.5']],
  JobSeachWoman: ['job-seach-woman', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5',
    transform: 'translate(-3.27 4.943) rotate(-23.025)'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M1.500 10.500 A9.000 9.000 0 1 0 19.500 10.500 A9.000 9.000 0 1 0 1.500 10.500 Z', 'M16.864 16.863L22.5 22.5', 'M14.724,15a4.513,4.513,0,0,0-2.383-2.591L10.5,15.75,8.659,12.409A4.518,4.518,0,0,0,6.275,15', 'M7.500 7.500 A3.000 3.000 0 1 0 13.500 7.500 A3.000 3.000 0 1 0 7.500 7.500 Z', 'M7.5,7.5s0,3.75-2.25,3.75', 'M13.5,7.5s0,3.75,2.25,3.75']]
};
exports["default"] = _default;